var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartScatter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8D97D58F-6D54-4118-A341-D101CBB911EF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Buy-Side-Risk",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-0-0-Obsido-Dashboard",
    transform: "translate(-18.000000, -353.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-(Portfolios)",
    transform: "translate(0.000000, 99.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart-scatter",
    transform: "translate(18.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "currentColor",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 1.96875,
    height: 16.75
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "currentColor",
    fillRule: "nonzero",
    transform: "translate(10.500000, 16.815625) rotate(90.000000) translate(-10.500000, -16.815625) ",
    points: "9.515625 6.315625 11.484375 6.315625 11.484375 27.315625 9.515625 27.315625"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    stroke: "currentColor",
    strokeWidth: 2,
    points: "6.5 10.5 8.88163451 6.07208191 12.7920233 9.20431549 17.2460435 2.67438607"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartScatter);
export default __webpack_public_path__ + "static/media/chart-scatter.37e82316.svg";
export { ForwardRef as ReactComponent };